import { Businesses } from "@just-in-types";
import { Reducer } from "redux";
import { ActionTypes, BusinessesAction, IBusinessRefsObject } from "../actions";

const businessesInitialState: IBusinessesState = {
  archivebusinesses: [],
  businessNames: {},
  businessPermissions: null,
  businesses: [],
  site: null,
  unsubscribeBusinesses: null,
  unsubscribeSite: null,
};

const usersReducer: Reducer<any, BusinessesAction> = (
  state = businessesInitialState,
  { type, payload }
): IBusinessesState => {
  switch (type) {
    case ActionTypes.GET_BUSINESSES: {
      const businessNames = {};

      if (Array.isArray(payload)) {
        payload.forEach(({ businessId, businessName }) => {
          businessNames[businessId] = businessName;
        });
      }

      return { ...state, businesses: payload, businessNames };
    }
    case ActionTypes.GET_ARCHIVEBUSINESSES: {
      return { ...state, archivebusinesses: payload };
    }
    case ActionTypes.GET_BUSINESSES_SUBSCRIPTION:
      return { ...state, unsubscribeBusinesses: payload };
    case ActionTypes.SET_REFS_OBJECT:
      return { ...state, businessPermissions: payload };
    case ActionTypes.GET_SITE:
      return { ...state, site: payload };
    case ActionTypes.GET_SITE_SUBSCRIPTION:
      return { ...state, unsubscribeSite: payload };
    default:
      return state;
  }
};

export default usersReducer;

export interface IBusinessesState {
  archivebusinesses: Businesses.Business[];
  businessNames: { [businessId: string]: string };
  businessPermissions: null | IBusinessRefsObject;
  businesses: Businesses.Business[];
  site: null | Businesses.Site;
  unsubscribeBusinesses: null | (() => void);
  unsubscribeSite: null | (() => void);
}



// WEBPACK FOOTER //
// ./src/store/reducers/businessesReducer.ts